import { initUsercentrics } from "./analytics/analytics"
import { interceptProxiedRequests } from "./network"
import { removeSession } from "./session"

declare global {
  interface Window {
    resetDemo: () => void
  }
}

export async function installDemo() {
  interceptProxiedRequests()
  // await prepareSession()
  await import("./analytics/segmentScript")
  initUsercentrics()

  window.resetDemo = resetDemo
}

function resetDemo() {
  removeSession()
  window.location.pathname = "/try/"
}
